/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import CircularProgress from "@material-ui/core/CircularProgress";
import grey from "@material-ui/core/colors/grey";

import styled from "styled-components";

const StyledCircularProgress = styled(CircularProgress)`
  ${(props) => {
    var size = props.size ?? 40;
    return `
      left: calc(50% - ${size / 2}px);
      right: calc(50% - ${size / 2}px);
      top: calc(50% - ${size / 2}px);
    `;
  }};

  position: absolute;
  z-index: 100;
  color: ${grey[500]};
`;

const Loader = (props) => {
  return (
    <StyledCircularProgress
      disableShrink={true}
      data-testid="loader"
      {...props}
    />
  );
};

export default Loader;
